import React from 'react';
import { CircularProgress } from '@mui/material';
import { StyledBox } from './Loader.styled';

const Loader: React.FC = () => {
  return (
    <StyledBox>
      <CircularProgress />
    </StyledBox>
  );
};

export default Loader;
